import { Checkmark16 } from '@ingrid/iconography/react';
import { DotBadge, FiltersBar, OptionList, SearchSelect, SelectTrigger } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { ShipmentStatuses, getStatusColor, getStatusLabel } from '~src/utils/status-helpers';

interface Props<TValue extends string> {
  onChange: (statuses: TValue[]) => void;
  value: TValue[];
}

export function StatusFilter<TValue extends string>({ onChange, value }: Props<TValue>) {
  const { t } = useTranslation();

  return (
    <SearchSelect.Root multiple onValueChange={values => onChange(values as TValue[])} value={value}>
      <SearchSelect.Trigger>
        <FiltersBar.Button>
          {t('common.status')}
          <SelectTrigger.Icon />
        </FiltersBar.Button>
      </SearchSelect.Trigger>
      <SearchSelect.Content>
        <OptionList.Viewport>
          {ShipmentStatuses.map(status => (
            <OptionList.Item key={status} value={status}>
              <DotBadge variant={getStatusColor(status)}>
                <OptionList.ItemText>{t(getStatusLabel(status))}</OptionList.ItemText>
              </DotBadge>
              <OptionList.ItemIndicator>
                <Checkmark16 />
              </OptionList.ItemIndicator>
            </OptionList.Item>
          ))}
        </OptionList.Viewport>
      </SearchSelect.Content>
    </SearchSelect.Root>
  );
}
